<template>
  <div style="width:100%" class="container">
    <monresto-header
      v-if="newItem[currentLang].themeOptions.header == 0"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
    <dropdown-header
      v-if="newItem[currentLang].themeOptions.header == 1"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
    <azour-header
      v-if="newItem[currentLang].themeOptions.header == 2"
      :viewType="true"
    
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
    <second-header-child
      v-if="newItem[currentLang].themeOptions.header == 3"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
    <monresto-body
      :newItem="newItem"
      :reserved_items="reserved_items"
      :quantities="quantities"
      :indexes="indexes"
      :SubstractQuanity="SubstractQuanity"
      :RemoveItem="RemoveItem"
      :AddQuanity="AddQuanity"
      :listSections="listSections"
      :restaurant="restaurant ? restaurant : {}"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :currentCurrency="currentCurrency"
      v-if="
        newItem[currentLang].themeOptions &&
          newItem[currentLang].themeOptions.body == 0
      "
      :currentLang="currentLang"
      :selectedLangues="selectedLangues"
      :addToCart="addToCart"
    />
    <dropdown-body
      :newItem="newItem"
      :listSections="listSections"
      :reserved_items="reserved_items"
      :quantities="quantities"
      :indexes="indexes"
      :SubstractQuanity="SubstractQuanity"
      :RemoveItem="RemoveItem"
      :AddQuanity="AddQuanity"
      :restaurant="restaurant ? restaurant : {}"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :currentCurrency="currentCurrency"
      v-if="
        newItem[currentLang].themeOptions &&
          newItem[currentLang].themeOptions.body == 1
      "
      :currentLang="currentLang"
      :selectedLangues="selectedLangues"
      :addToCart="addToCart"
    />
    <azour-body
      :viewType="true"
      :newItem="newItem"
      :reserved_items="reserved_items"
      :quantities="quantities"
      :indexes="indexes"
      :SubstractQuanity="SubstractQuanity"
      :RemoveItem="RemoveItem"
      :AddQuanity="AddQuanity"
      :listSections="listSections"
      :restaurant="restaurant ? restaurant : {}"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :currentCurrency="currentCurrency"
      v-if="
        newItem[currentLang].themeOptions &&
          newItem[currentLang].themeOptions.body == 2
      "
      :currentLang="currentLang"
      :selectedLangues="selectedLangues"
      :addToCart="addToCart"
      :selectes_ids="selectes_ids"
    />
    <second-body-child
      v-if="newItem[currentLang].themeOptions.body == 3"
      :log="log"
      :reserved_items="reserved_items"
      :quantities="quantities"
      :indexes="indexes"
      :SubstractQuanity="SubstractQuanity"
      :RemoveItem="RemoveItem"
      :AddQuanity="AddQuanity"
      :functionCollapsed="functionCollapsed"
      :newSection="newSection"
      :newItem="newItem"
      :listSections="listSections"
      :restaurant="restaurant ? restaurant : {}"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :changeSectionTitle="changeSectionTitle"
      :changeSectionSubTitle="changeSectionSubTitle"
      :addItem="addItem"
      :newSubSection="newSubSection"
      :handleChangeShowSub="handleChangeShowSub"
      :disponibleItem="disponibleItem"
      :showItem="showItem"
      :changeItemObservation="changeItemObservation"
      :changeItemTitle="changeItemTitle"
      :changeItemPrice="changeItemPrice"
      :editCategorie="editCategorie"
      :deleteSection="deleteSection"
      :editSubCategorie="editSubCategorie"
      :deleteSubSection="deleteSubSection"
      :editItem="editItem"
      :currentCurrency="currentCurrency"
      :deleteItem="deleteItem"
      :addToCart="addToCart"
      :selectes_ids="selectes_ids"
    />

    <second-footer-child
      v-if="newItem[currentLang].themeOptions.footer == 2"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant"
    />
    <dropdown-footer-child
      v-if="newItem[currentLang].themeOptions.footer == 1"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant"
    />
  </div>
</template>

<script>
import MonrestoHeader from "./headers/monresto.vue";
import DropDownHeader from "./headers/dropdown";
import AzourownHeader from "./headers/azour";
import MonrestoBody from "./body/monresto.vue";
import DropDownBody from "./body/dropdown.vue";
import AzourBody from "./body/azour.vue";
import SecondBody from "./body/second-body.vue";
import SecondFooter from "./footer/footer-second.vue";
import DropDownFooter from "./footer/dropdown.vue";
import SecondHeader from "./headers/second-header.vue";
export default {
  components: {
    "monresto-header": MonrestoHeader,
    "dropdown-header": DropDownHeader,
    "azour-header": AzourownHeader,
    "monresto-body": MonrestoBody,
    "dropdown-body": DropDownBody,
    "azour-body": AzourBody,
    "second-body-child": SecondBody,
    "second-footer-child": SecondFooter,
    "dropdown-footer-child": DropDownFooter,
    "second-header-child": SecondHeader,
  },
  props: [
    "indexes",
    "quantities",
    "reserved_items",
    "newItem",
    "newItem",
    "listSections",
    "restaurant",
    "currentTab",
    "setCurrentTab",
    "currentCurrency",
    "currentLang",
    "selectedLangues",
    "addToCart",
    "selectes_ids",
    "SubstractQuanity",
      "RemoveItem",
      "AddQuanity",
  ],

  data() {
    return {};
  },
  mounted() {
    // console.clear();
    // console.log(this.newItem[0]);
    //   alert('HEEEHE')
    //   console.log('HEHEHEHEHEHEHEKHSHSHSKKSH');
  },
};
</script>

<style></style>
